<template>
  <v-container
    id="templateTab"
    class="pa-0"
  >
    <template-sections
      :open-enrollment="openEnrollment"
      :disabled="disabled"
      @change="itemChanged"
      @answers:saved="itemChanged"
      @answers:removed="itemChanged"
    />
    <base-history-dialog
      resource-endpoint="oeTemplateHistory/"
      id-field="oeTemplateId"
      title-field="Template"
      color="green"
      :columns="historyColumns"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'TemplateTab',

    components: {
      TemplateSections: () => import('./TemplateSections'),
    },

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      formErrors: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      gridHeaders: [
        {
          text: 'Section',
          value: 'templateSection',
        },
        {
          text: 'Question',
          value: 'question',
        },
        {
          text: 'Answer',
          value: 'answer',
        },
      ],

      historyColumns: [
        {
          text: 'Answer',
          value: 'answer',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      templateAnswerResource: new TroodyApi('oeTemplateAnswer/'),
      templateResource: new TroodyApi('oeTemplate/'),

      historyItem: null,
    }),

    methods: {
      getTemplate () {
        // return this.templateAnswerResource.getList()
        return this.templateAnswerResource.query({ openEnrollmentId: this.openEnrollment.id })
      },

      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },

      itemChanged (data) {
        this.$emit('item:changed', data)
      },

      prepareSave (payload) {
        if (payload) {
          payload.openEnrollmentId = this.openEnrollment.id
        }
        return payload
      },
    },
  }
</script>
